<template>
  <div class="user-listing-detail">
    <div
      class="
        Head-div
        p-3
        d-flex
        justify-content-between
        align-items-center
        border-bottom
      "
    >
      <h4 class="mb-0">Hospital Detailws</h4>
      <div class="cursor" @click.stop="$emit('close')">
        <crossSVG />
      </div>
    </div>
    <CCol sm="12" class="px-0 inner-scroller">
      <CCol sm="12" class="user-profile-info border-bottom">
        <div class="media">
          <!-- <div class="media-body">
            <h3 class="mt-0 font-weight-normal text-capitalize"></h3>
          </div> -->
          <div>
            <v-btn color="red" dark>Deactivate</v-btn>
          </div>
        </div>
      </CCol>
      <!-- .... end user-profile-info ... -->
      <CCol sm="12" class="px-0 pb-0">
        <CCol sm="12" class="pt-0 border-bottom">
          <h6 class="mb-0 text-dark">Hospital Owner Details</h6>
        </CCol>
        <CCol sm="12" class="border-bottom">
          <CRow>
            <CCol sm="6" md="4">
              <p class="text-dark mb-0">Name : Sid</p>
              <p></p>
            </CCol>
            <CCol sm="6" md="4">
              <p class="text-dark mb-0">Mobile Number : 1234567890</p>
              <p></p>
            </CCol>
            <CCol sm="6" md="4">
              <p class="text-dark mb-0">Email : sid@relifems.com</p>
              <p></p>
            </CCol>
            <CCol sm="6" md="4">
              <p class="text-dark mb-0">Gender : Male</p>
              <p></p>
            </CCol>
            <CCol sm="6" md="4">
              <p class="text-dark mb-0">DOB : 3/3/1992</p>
              <p></p>
            </CCol>
            <CCol sm="6" md="4">
              <p class="text-dark mb-0">Age : 30</p>
              <p></p>
            </CCol>
          </CRow>
        </CCol>
      </CCol>
      <CCol sm="12" class="px-0">
        <!-- .... Hospital Detail ... -->
        <CCol sm="12" class="p-0">
          <CCol sm="12" class="pt-0 border-bottom">
            <h6 class="mb-0 text-dark">Hospital Details</h6>
          </CCol>
          <CCol sm="12" class="border-bottom">
            <CRow>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">No. of Beds : 50</p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Hospital Existing Since : 1/1/2012</p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Type : Private</p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Speciality : Ophthalmology</p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Emergency Service Type : Yes <span>(Medical Emergency)</span>
                </p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">hospital is a Daycare : No</p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Hospital Registration Number : AN2189374YUW0
                </p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Hospital Registration Certificate :
                  <button
                    type="button"
                    class="
                      view-certificate
                      v-btn v-btn--is-elevated v-btn--has-bg
                      theme--light
                      v-size--large
                    "
                  >
                    <span class="v-btn__content">View</span>
                  </button>
                </p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Facilities : (Angiography, Bypass)</p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Is it a Standalone Hospital : Yes</p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Is Hospital a Teaching Institute for Doctors : No
                </p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Cashless services for admission : Yes
                  <span>(Bajaj Healthcare)</span>
                </p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Accreditations : <span class="tags">#tags</span>
                </p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Medical Tourism available : Yes</p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4" class="cover-image">
                <p class="text-dark mb-0">Cover Image :</p>
                <div class="file-attachment d-flex align-items-center">
                  <fileSVG />
                  <p class="ml-2 mb-0 cursor"></p>
                </div>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Other images of Hospital :
                  <button
                    type="button"
                    class="
                      view-hospital
                      v-btn v-btn--is-elevated v-btn--has-bg
                      theme--light
                      v-size--large
                    "
                  >
                    <span class="v-btn__content">View</span>
                  </button>
                </p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Description : Lorem ipsum dolor sit amet consectetur
                  adipisicing elit. Libero illo ad veritatis aspernatur hic
                  autem nulla non? Possimus omnis nemo repellendus dolorem
                  numquam, molestias, officia delectus voluptatum, mollitia
                  soluta perspiciatis!
                </p>
                <p></p>
              </CCol>
            </CRow>
          </CCol>
        </CCol>
        <!-- .... End Hospital Detail ... -->
        <!-- .... Ward Detail ... -->
        <CCol sm="12" class="px-0 pb-0">
          <CCol sm="12" class="pt-0 border-bottom">
            <h6 class="mb-0 text-dark">Ward Details</h6>
          </CCol>
          <CCol sm="12" class="border-bottom">
            <CRow>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Ward Type : General</p>
                <p class="text-dark mb-0">No. of beds / rooms : 25</p>
                <p class="text-dark mb-0">Charge / day : 500</p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Ward Type : Delux</p>
                <p class="text-dark mb-0">No. of beds / rooms : 10</p>
                <p class="text-dark mb-0">Charge / day : 3500</p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Ward Type : Super Delux</p>
                <p class="text-dark mb-0">No. of beds / rooms : 15</p>
                <p class="text-dark mb-0">Charge / day : 9500</p>
                <p></p>
              </CCol>
            </CRow>
          </CCol>
        </CCol>
        <!-- .... End Ward Detail ... -->
        <!-- ...... Doctor Detail ...... -->
        <CCol sm="12" class="p-0">
          <CCol sm="12" class="border-bottom">
            <h6 class="mb-0 text-dark">Doctor Details</h6>
          </CCol>
          <CCol class="border-bottom">
            <div class="doctor-summary-table mb-5">
              <table>
                <thead class="doc-bg">
                  <tr>
                    <th class="p-font font-weight-bold">First Name</th>
                    <th class="p-font font-weight-bold">Last Name</th>
                    <th class="p-font font-weight-bold">Mobile Number</th>
                    <th class="p-font font-weight-bold">Branch of Medicine</th>
                    <th class="p-font font-weight-bold">Speciality</th>
                    <th class="p-font font-weight-bold">Qualification</th>
                    <th class="p-font font-weight-bold">Empaneled on</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="p-font text-default">Sid</td>
                    <td class="p-font text-default">Padwal</td>
                    <td class="p-font text-default">324535345</td>
                    <td class="p-font text-default">jkdjkc</td>
                    <td class="p-font text-default">-</td>
                    <td class="p-font text-default">-</td>
                    <td class="p-font text-default">12-33-22</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- <CCol sm="6" md="4">
                <p class="text-dark mb-0">First Name : Deepak</p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Last Name : Baid</p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Mobile Number : 0987654321</p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Branch of Medicine :</p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Specialty :</p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Qualification :</p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">In Practice Since :</p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Years Of Practice :</p>
                <p></p>
              </CCol> -->
          </CCol>
        </CCol>
        <!-- ...... end Address Info ...... -->
      </CCol>
    </CCol>

    <image-preview
      @close="closeImageModal"
      v-if="openImageModal"
      :openImageModal="openImageModal"
      :source="fileUrl"
      :fileArcheType="fileArcheType"
    ></image-preview>
  </div>
</template>
<script>
import config from "@/config.js";
import { pickSvg } from "@/views/SVG";
import "@/assets/scss/_userDetails.scss";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .build();
import formats from "@/formats";
export default {
  props: ["centerId"],
  data() {
    return {
      centerInfo: {},
      isEmpty: true,
      openImageModal: false,
      fileUrl: "",
      fileArcheType: "",
      dayJS,
      formats,
    };
  },
  components: {
    "light-box-new": () => import("@/components/lightBoxNew.vue"),
    "image-view": () => import("@/components/image.vue"),
    "image-preview": () => import("@/components/modals/imagePreview.vue"),

    ...pickSvg("crossSVG", "fileSVG"),
    loader: () => import("@/components/loader.vue"),
  },

  mounted() {
    // this.getDiagnosticDetails();
  },
  methods: {
    closeImageModal() {
      this.openImageModal = false;
    },
    openModal(fileUrl, fileArcheType) {
      this.fileUrl = fileUrl;
      this.fileArcheType = fileArcheType;
      this.openImageModal = true;
    },
    getDiagnosticDetails() {
      this.$store.commit("general/setLoader", true);
      let role = "diagnostics-lab";
      let url = `${config.BASE_URL}api/v2/admin/centers/${this.centerId}/profile?role=${role}`;
      this.$http.get(url).then((response) => {
        if (response.body.status) {
          this.$store.commit("general/setLoader", false);
          this.centerInfo = response && response.body && response.body.data;
          this.isEmpty = false;
        } else {
          this.$store.commit("general/setLoader", false);
          this.isEmpty = true;
        }
      });
    },
  },
};
</script>

<style scoped>
.user-profile-info {
  padding-top: 0 !important;
}
.view-certificate,
.view-hospital {
  height: 22px !important;
  font-size: 12px !important;
}
.cover-image {
  display: flex !important;
  align-items: center !important;
}

table {
  font-size: 0.9em;
  width: 100%;
  border-collapse: collapse;
  overflow: auto;
}

th {
  text-align: left;
}

thead {
  font-weight: bold;
  color: #000;
  background: #e4e4e45e;
}

td,
th {
  padding: 1em 0.5em;
  vertical-align: middle;
}

td {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  background: #fff;
  text-align: left;
}

.head {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
</style>